import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal, ResponsiveWidth } from '../../../common/modal';
import { EcpFiltersModalForm } from './ecp-filters-modal-form';
import { useStyles } from './ecp-filters-modal.styles';
import { IEcpFiltersModalViewProps } from './ecp-filters-modal.models';
import { Button } from '../../../common/button-new';
import { IFormImperativeHandleProps } from '../../../common/form';

export const EcpFiltersModal = forwardRef<IFormImperativeHandleProps, IEcpFiltersModalViewProps>(({
  defaultValues,
  isResetButtonDisabled,
  onApplyFilters,
  onSubmitButtonClick,
  onResetFilters,
  ecpService,
  ...props
}, ref): JSX.Element => {
  const classes = useStyles();

  return (
    <Modal
      {...props}
      responsiveWidth={ResponsiveWidth.lg}
      content={(
        <EcpFiltersModalForm
          ref={ref}
          defaultValues={defaultValues}
          onApplyFilters={onApplyFilters}
          ecpService={ecpService}
        />
      )}
      propsPaperStyles={classes.paper}
      propsContentStyles={classes.content}
      footer={(
        <div className={classes.actions}>
          <div className={classes.resetButton}>
            <Button
              style="outlined"
              disabled={isResetButtonDisabled}
              onClick={onResetFilters}
              testId="filters-modal-reset-button"
            >
              <FormattedMessage
                id="ecp.filters.modal.resetFiltersButton.label"
              />
            </Button>
          </div>
          <Button
            style="dark"
            onClick={onSubmitButtonClick}
            testId="ecp-filter-submit-button" // Don't remove, used by YA analitics
          >
            <FormattedMessage
              id="ecp.filters.modal.applyFiltersButton.label"
            />
          </Button>
        </div>
      )}
    />
  );
});
